import { client } from '../data/client'

const authProvider = {
  login: async (token) => {
    try {
      // Verify the token with the API
      const encodedToken = encodeURIComponent(token)
      const response = await client().get(`/provider-portal/verify-provider-access/${encodedToken}`)

      if (response.status === 200 && response.data.verified) {
        // Store the token in localStorage
        localStorage.setItem('provider_portal_access_token', response.data.token)
        localStorage.setItem('provider_portal_customer_full_name', response.data.fullName)
        localStorage.setItem('provider_portal_customer_email', response.data.email)
        localStorage.setItem('provider_portal_customer_id', response.data.customerId)
        localStorage.setItem('provider_portal_kit_requests', response.data.kitRequests ? 'true' : 'false')
        return Promise.resolve()
      }

      return Promise.reject({ message: 'Invalid access token' })
    } catch (error) {
      return Promise.reject({ message: 'Authentication failed' })
    }
  },
  logout: (params) => {
    localStorage.removeItem('provider_portal_access_token')
    localStorage.removeItem('provider_portal_customer_full_name')
    localStorage.removeItem('provider_portal_customer_email')
    localStorage.removeItem('provider_portal_customer_id')
    localStorage.removeItem('provider_portal_kit_requests')
    return Promise.resolve('/login?state=logout')
  },
  checkAuth: async (params) => {
    if (
      localStorage.getItem('provider_portal_access_token') &&
      localStorage.getItem('provider_portal_access_token') !== 'undefined' &&
      localStorage.getItem('provider_portal_access_token') !== 'logout'
    ) {
      const token = localStorage.getItem('provider_portal_access_token')
      const response = await client().get(`/provider-portal/verify-jwt?token=${token}`)
      if (response.data.verified) {
        return Promise.resolve()
      }

      return Promise.reject({ redirectTo: '/login' })
    }
    return Promise.reject({ redirectTo: '/login' })
  },
  checkError: (error) => {
    const status = error?.response?.status || error?.status
    if (status === 401 || status === 403) {
      return Promise.reject('Unauthorized')
    }
    return Promise.resolve()
  },
  getIdentity: (params) => {
    const fullName = localStorage.getItem('provider_portal_customer_full_name')
    const email = localStorage.getItem('provider_portal_customer_email')

    const fullNameWithEmail =
      fullName && email ? `${fullName} (${email})` : fullName || email || ''

    return Promise.resolve({
      fullName: fullNameWithEmail,
      email,
      customerId: localStorage.getItem('provider_portal_customer_id'),
      kitRequests: localStorage.getItem('provider_portal_kit_requests') === 'true',
    })
  },
  getPermissions: (params) => Promise.reject('Unauthorized'),
}

export default authProvider
